<template>
  <div id="app">
    <commonhead :active_menu="-1" />
    <div class="user_center_order my_style">
      <div class="content_wrap">
        <!--个人中心公用侧边栏-->
        <UserLeftMenu :active_menu_index="2" />
        <div class="order_list">
          <Table
            :data="bookData"
            style="width: 100%"
            :header-cell-style="{background:'rgba(239,242,249,1)',color:'rgba(40,40,40,1)','text-align':'center'}"
            :cell-style="{'text-align':'center','font-size':'14px'}"
          >
            <TableColumn prop="date" label="序号"></TableColumn>
            <TableColumn prop="name" label="书名"></TableColumn>
            <TableColumn prop="address" label="作者"></TableColumn>
            <TableColumn prop="address" label="语言"></TableColumn>
            <TableColumn label="下载">
              <template slot-scope="scope">
                <Button size="mini" type="success" @click="handleEdit(scope.$index, scope.row)">已下载</Button>
                <Button
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row)"
                >点击下载</Button>
              </template>
            </TableColumn>
          </Table>
          <!--分页器-->
          <div class="pagination pr">
            <Pagination
              background
              @current-change="getList"
              :page-size="10"
              layout="total, prev, pager, next"
              :total="bookData.total || 0"
            >></Pagination>
          </div>
        </div>
      </div>
    </div>
    <!--底部信息-->
    <div class="bottom">
      <div class="content pr">
        <span class="gift">
          <img src="../../assets/image/user_center/icon (1).png" alt class="pic_full" />
        </span>
        <span class="free_info">
          每成功推荐一个朋友学习，满足奖励条件后即可获得
          <span class="red">200元充值</span>，奖励可累积哦！
        </span>
        <div class="qr_code">
          <div class="qrcode_img">
            <canvas id="QRCode"></canvas>
          </div>
          <p class="notice_info">
            <span class="wechat_icon">
              <img src="../../assets/image/user_center/icon (2).png" alt class="pic_full" />
            </span>
            <span>扫码分享到微信</span>
          </p>
        </div>
        <button class="call_btn hand_point">查看奖励</button>
      </div>
    </div>
    <!--公共底部-->
    <commonfoot />
    <!--公共底部-->
  </div>
</template>

<script>
import { common } from "../../../common.js";
import commonhead from "../common/common_head.vue";
import commonfoot from "../common/common_foot.vue";
import UserLeftMenu from "../common/user_left_menu.vue";
import { Table, TableColumn, Button, Pagination } from "element-ui";
import QRCode from "qrcode"; //引入生成二维码插件
export default {
  name: "app",
  components: {
    commonhead,
    commonfoot,
    UserLeftMenu,
    Table,
    TableColumn,
    Button,
    Pagination
  },
  data: function() {
    return {
      bookData: []
    };
  },
  mounted: function() {
    this.getList(1);
    this.get_share_code();
  },
  methods: {
    handleEdit(index, row) {
      window.console.log(index, row);
    },
    handleDelete(index, row) {
      window.console.log(index, row);
    },
    getList(page) {
      //获取列表
      let self = this;
      common.requestFun(
        self,
        "get",
        "/student/recommend/book",
        {
          page: page
        },
        res => {
          if (res.data.code == 200) {
            self.bookData = res.data.data;
          }
        }
      );
    },
    get_share_code() {
      //生成分享二维码
      let self = this;
      common.requestFun(self, "get", "/student/recommend_code", {}, res => {
        if (res.data.code == 200) {
          var msg = document.getElementById("QRCode");
          QRCode.toCanvas(
            msg,
            `http://gemsbaby.com/share/index.html?origin_code=${res.data.data}`,
            function(error) {
              console.log(error);
            }
          );
        }
      });
    }
  }
};
</script>
<style scoped src="./user_center_course.css"></style>
